import get from 'lodash.get';

const getPartnerName = (rootState) => get(rootState, 'user.partnerData.name', null);

export default getPartnerName;
